import { msg } from '@lingui/core/macro';
import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import type { MessageDescriptor } from 'shared/i18n';
import { Tab } from 'ud-ui/components/tabs/interfaces';

/** Вкладка с подписью-дескриптором: переводит вызывающая сторона в рендере (`t(tab.label)`). */
export type ChampionshipEditTabDefinition = Omit<Tab, 'label'> & { label: MessageDescriptor };

/**
 * Подписи и порядок вкладок формы редактирования соревнования.
 *
 * Подписи — дескрипторы, а не строки: строка, посчитанная на импорте модуля, не пережила бы
 * смену языка. Hash-и — в `domain/enums/championship-edit-tab.ts`, они часть роута.
 *
 * `isFlow1447` — A/B-флаг `applicationsFlow1447` (ветка IMGM-1447 против продакшена): переименовал
 * три из пяти подписей и убрал стрелку после подписи неактивной вкладки (`showArrow`, ud-ui).
 * Оба варианта подписи — в каталоге: это временная развилка A/B-теста, но переключение языка
 * не должно зависеть от того, в какую ветку попал пользователь. Оба вызывающих
 * (`edit-form/tabs.tsx`, `create-form/tabs.tsx`) обязаны передавать актуальное значение флага —
 * экран создания соревнования тоже должен сразу показывать нужный вариант.
 */
export const getChampionshipEditTabs = (isFlow1447: boolean): ChampionshipEditTabDefinition[] => [
  {
    hash: ChampionshipEditTab.COMMON,
    label: isFlow1447 ? msg`О турнире` : msg`Основные данные`,
    showArrow: !isFlow1447,
  },
  {
    hash: ChampionshipEditTab.RULES,
    label: isFlow1447 ? msg`Параметры` : msg`Условия`,
    showArrow: !isFlow1447,
  },
  {
    hash: ChampionshipEditTab.TEAMS,
    label: isFlow1447 ? msg`Команды` : msg`Заявки`,
    showArrow: !isFlow1447,
  },
  { hash: ChampionshipEditTab.STEPS, label: msg`Этапы`, showArrow: !isFlow1447 },
  { hash: ChampionshipEditTab.MEDIA, label: msg`Медиа`, showArrow: !isFlow1447 },
  { hash: ChampionshipEditTab.SYMBOLIC_TEAMS, label: msg`Сборные`, showArrow: !isFlow1447 },
  // Вкладки GAMES, APPLICATIONS и RESULTS были закомментированы до этой задачи.
];
